import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Employee } from '../models/employee.model';
import { CreateEmployeeDto } from '../models/dtos/createEmployee.dto';
import { UpdateEmployeeDto } from '../models/dtos/updateEmployee.dto';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  private readonly baseUrl = `${environment.base_url}/employees`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<RestResponse<Employee[]>> {
    return this.http.get<RestResponse<Employee[]>>(`${this.baseUrl}`);
  }

  create(dto: CreateEmployeeDto): Observable<RestResponse<Employee>> {
    return this.http.post<RestResponse<Employee>>(`${this.baseUrl}/create`, dto);
  }

  update(id: number, dto: UpdateEmployeeDto): Observable<RestResponse<Employee>> {
    return this.http.put<RestResponse<Employee>>(`${this.baseUrl}/update/${id}`, dto);
  }

  find(id: number): Observable<RestResponse<Employee>> {
    return this.http.get<RestResponse<Employee>>(`${this.baseUrl}/find/${id}`);
  }

  list(search: string = '', active?: boolean, page: number = 1): Observable<RestResponse<Employee[]>> {
    const params: any = { page };
    if (search) params.search = search;
    if (active !== undefined) params.active = active;
    return this.http.get<RestResponse<Employee[]>>(`${this.baseUrl}/list`, { params });
  }

  delete(id: number): Observable<RestResponse<object>> {
    return this.http.delete<RestResponse<object>>(`${this.baseUrl}/delete/${id}`);
  }
}
